import React from 'react';
import MenuState from './Container';

const ToggleBar = () => {
    const menuState = MenuState.useContainer();
    return (
        <div
            className="toggleBar"
            onClick={() => menuState.setMenuCollapsed(!menuState.menuCollapsed)}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                viewBox="0,0,16,66"
            >
                <g
                    fill="none"
                    fillRule="evenodd"
                >
                    <path
                        className="rectPath"
                        d="M0 0 L14 6 A4 4 0 0 116 10 v46 a4 4 0 0 1-2 4 L0 66 z"
                        fill="#ffffff" />
                    {menuState.menuCollapsed ? (
                        <path
                            d="M5 25 L11 32 L5 39"
                            className="arrowPath" />
                    ) : (
                        <path
                            d="M10 25 L5 32 L10 39"
                            className="arrowPath" />
                    )}
                </g>
            </svg>
        </div>
    );
};

export default ToggleBar;
